export default {
    gardenGnome: {
        icon: 'mdi-human-child'
    },
    sprinkler: {
        icon: 'mdi-sprinkler-variant'
    },
    lectern: {
        icon: 'mdi-lectern'
    },
    pinwheel: {
        icon: 'mdi-pinwheel'
    },
    flag: {
        icon: 'mdi-flag'
    }
}
